import { select } from 'redux-saga/effects';
import { CONTENT_LIBRARY_SORT_BY_STORAGE_KEY } from 'features/content-library/constants';
import { selectContentLibrarySortBy } from 'features/content-library/contentLibrarySlice';
import { ContentLibrarySortBy } from 'features/content-library/types';
import { safeLocalStorage } from 'utils/storage';

export function* persistContentLibrarySortBySaga() {
  const sortBy: ContentLibrarySortBy = yield select(selectContentLibrarySortBy);

  safeLocalStorage.setItem(CONTENT_LIBRARY_SORT_BY_STORAGE_KEY, sortBy);
}
